import React from 'react';
import PropTypes from 'prop-types';
import {getDimensions, SIZE} from '../../utils/IntegrationIconSizer';
import {FixedColorsIcon} from '../FixedColorsIcon';

export const EconomicIcon = ({size, onClick}) => {
	const dimensions = getDimensions(size);

	const handleClick = e => {
		e.stopPropagation();
		onClick(e);
	};
	const optionalHandleClick = onClick ? handleClick : undefined;

	return (
		<FixedColorsIcon onClick={optionalHandleClick} width={dimensions} height={dimensions}>
			<svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg" width={dimensions} height={dimensions}>
				<path
					fill="#F09000"
					d="M 357.647 417.59 C 357.803 460.676 322.997 495.721 279.913 495.876 C 236.841 496.03 201.787 461.232 201.635 418.145 C 201.48 375.069 236.285 340.009 279.357 339.855 C 322.442 339.701 357.493 374.51 357.647 417.59"
				></path>
				<path
					fill="#F09000"
					d="M 91.465 345.848 C 91.537 366.412 74.923 383.139 54.358 383.215 C 33.792 383.285 17.065 366.678 16.99 346.112 C 16.917 325.554 33.525 308.823 54.092 308.753 C 74.658 308.677 91.391 325.285 91.465 345.848"
				></path>
				<path
					fill="#F09000"
					d="M 478.231 98.73 C 478.044 46.269 435.326 3.845 382.844 4.033 C 334.185 4.207 294.204 40.958 288.806 88.146 C 288.791 88.22 288.762 88.264 288.762 88.332 C 286.393 105.716 283.422 147.786 262.802 165.982 C 253.003 174.66 243.855 187.498 197.232 179.926 L 197.261 179.97 C 186.784 178.022 168.049 175.041 158.372 158.717 C 150.704 145.757 155.899 124.425 158.127 114.708 C 159.536 110.265 160.291 105.539 160.273 100.646 C 160.183 75.172 139.476 54.614 114.021 54.709 C 88.548 54.8 67.982 75.504 68.074 100.973 C 68.138 119.256 78.877 134.977 94.353 142.38 L 94.281 142.404 C 110.299 149.792 124.497 155.353 130.504 169.976 C 136.282 184.095 126.525 214.162 123.729 222.148 C 123.526 222.774 123.262 223.375 123.075 224.012 C 123.03 224.095 123.016 224.155 123.016 224.155 L 123.031 224.139 C 121.24 230.095 120.264 236.415 120.286 242.95 C 120.411 278.263 149.143 306.791 184.437 306.666 C 212.546 306.567 236.278 288.331 244.771 263.106 L 244.818 263.182 C 248.394 253.677 251.644 217.433 283.609 200.08 C 304.82 188.542 350.627 192.046 373.277 193.587 C 375.774 193.827 378.316 193.978 380.865 194.036 C 382.774 194.131 384.257 194.162 385.218 194.108 C 385.306 194.09 385.342 194.056 385.41 194.04 C 437.029 192.856 478.416 150.597 478.231 98.73"
				></path>
			</svg>
		</FixedColorsIcon>
	);
};

EconomicIcon.SIZE = SIZE;
EconomicIcon.propTypes = {
	onClick: PropTypes.func,
	size: PropTypes.oneOf(Object.values(SIZE)),
};
